<section>
    <div class="termns-conditions--container">
        <p class="terms-conditions--title">Términos y condiciones</p>
        <div class="terms-conditions--text">
            <pdf-viewer [src]="data.pdfSrc"
             [mobileZoom]="1"
             [show-all]="true"
             [render-text]="true"
            [original-size]="false"></pdf-viewer>
        </div>
        <div class="terms-conditions--button-container">
            <button mat-raised-button mat-dialog-close class="terms-conditions--button">Volver</button>
        </div>
    </div>
</section>